<template>
  <div class="col-6 form-section ignore-screen u-text-right">
    <label id="page-num-label"
      >Results per page:
      <select
        id="page-num-select"
        class="select input-xsmall"
        v-model="value"
        @change="handleChange($event.target.value)"
      >
        <option selected value="0">Default</option>
        <option
          v-for="(val, idx) in options"
          :key="`pagesize-${idx}`"
          :value="val"
          >{{ val }}</option
        >
      </select>
    </label>
  </div>
</template>
<style>
#page-num-label {
  display: inline-block;
  width: 100%;
  color: var(--cirrus-dark);
}
#page-num-select {
  margin-left: 1rem;
  min-width: 5rem !important;
  max-width: 7rem;
}
</style>
<script>
import { mapGetters } from "vuex";

export default {
  name: "page-size-selector",
  data: function() {
    return {
      value: "",
      options: [5, 10, 20, 30, 50]
    };
  },
  computed: {
    ...mapGetters("core", ["pageSize"])
  },
  methods: {
    handleChange(value) {
      this.$store.commit("core/setPageSize", value);
      this.$emit("handle-page-size");
    }
  },
  mounted() {
    if (this.pageSize > 0) {
      this.value = this.pageSize;
    }
  }
};
</script>
